var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskForBuyer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.48242 6.7998C8.13928 6.7998 9.48242 5.45666 9.48242 3.7998C9.48242 2.14295 8.13928 0.799805 6.48242 0.799805C4.82557 0.799805 3.48242 2.14295 3.48242 3.7998C3.48242 5.45666 4.82557 6.7998 6.48242 6.7998Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87271 8.92532C8.1676 8.56097 7.38917 8.37181 6.6 8.37305C3.78335 8.37305 1.5 10.7205 1.5 13.6161",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5007 9.53809L16.3693 15.5626C16.2882 15.7914 16.0774 15.9444 15.8404 15.9463H11.7816C11.5548 15.946 11.3498 15.8071 11.2602 15.5928L10.0461 12.1014C9.97073 11.9213 9.98862 11.7144 10.0937 11.5509C10.1987 11.3873 10.3768 11.2891 10.5674 11.2897H17.8819",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5509 17.6943C12.7074 17.6943 12.8342 17.8247 12.8342 17.9856C12.8342 18.1465 12.7074 18.2769 12.5509 18.2769C12.3944 18.2769 12.2676 18.1465 12.2676 17.9856C12.2676 17.8247 12.3944 17.6943 12.5509 17.6943",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3829 17.6943C15.5394 17.6943 15.6663 17.8247 15.6663 17.9856C15.6663 18.1465 15.5394 18.2769 15.3829 18.2769C15.2265 18.2769 15.0996 18.1465 15.0996 17.9856C15.0996 17.8247 15.2265 17.6943 15.3829 17.6943",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskForBuyer);
export default __webpack_public_path__ + "static/media/AskForBuyer.5b958bd41886d61acc0bfc0d34480178.svg";
export { ForwardRef as ReactComponent };